import { useContext } from "react";
import { CollaboratorsContext } from "./CollaboratorsContext";

export const useCollaborators = () => {
  const { activeCollaborators } = useContext(CollaboratorsContext);
  return { activeCollaborators };
};
